import React, { Component } from 'react';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppConfig } from '../../AppConfig';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { Controller } from '../../common/Controller';

import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';

export class ProductImages extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageTitle = 'Product Images'
    this.prodId = this.props.match.params.id
    this.breadCrumbs = [
      { title: 'Home', to: '/admin' },
      { title: this.pageTitle },
    ]
    this.entityAttrName = 'images'
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['products', this.prodId ], { pb: 'fieldDefImages' }) },
    ]
    this.tableHeadersMap = {
      Id: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.id}</span>
          </div>
        )
      },
      Order: (current) => current.order,
      Title: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      brandId: this.brandId
    }
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDefImages
    this.pageTitle = 'Images - ' + results[0].title
    this.setState({
      items: results[0].images ? Helper.dictToArray(results[0].images) : []
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: this.entityAttrName },
      apiEndPoint: ApiHelper.makeUrlPath(['products', this.prodId]),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'del', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['products', this.prodId]),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: this.entityAttrName, id: current.id },
      apiEndPoint: ApiHelper.makeUrlPath(['products', this.prodId]),
    });
  }

  onActions = (current) => {
    const actions = []
    actions.push(AppHelper.buttonEdit(this, current))
    actions.push(AppHelper.buttonDelete(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/ProductImages.js